export type IndicatorId = "volume" | "historicalVolume" | "buyPrice" | "sellPrice" | "historicalPrice" | "rsi" | "ma" | "ema" | "bb" | "macd";

export interface ColorOption {
    color?: string;
    id: string;
    label: string;
    seriesKey: string;
}

export interface Option {
    id: string;
    label: string;
    value: string | number;
    defaultValue?: string | number;
    type: string;
    options?: string[];
}

export interface Indicator {
    id: IndicatorId;
    enabled: boolean;
    options?: Option[];
    colorOptions: ColorOption[];
    pane?: number | null;
    period?: number;
    maType?: string;
    bbMult?: number;
    maLength?: number;
    fast?: number;
    slow?: number;
    signal?: number;
    smaSource?: string;
    smaSignal?: string;
    overbought?: number;
    oversold?: number;
}

export const getColorOption = (colorOptions: ColorOption[], colorId: string): string | undefined => {
    return colorOptions.find((option) => option.id === colorId)?.color;
};

export const getOption = (indicator: Indicator, optionId: string): Option | undefined => {
    return indicator.options?.find((option) => option.id === optionId);
};
